export default __webpack_public_path__ + "static/media/runningEmoji.7f805d30.png";